
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    short: "0.73.7",
    version: "0.73.7 (e04ee0910829f6c959f628ca14fd172c)",
    buildSeed: 1658134819140,
};
